import React,{useEffect, useState} from 'react'
import Instagram from './instagram.svg';
import Linkedin from './linkedin.svg';
import Github from './github.svg';
import Twitter from './twitter.svg';
import Smiley from './smiley.svg'
import emailjs from 'emailjs-com';
import PulseLoader from "react-spinners/PulseLoader";
import {Button,InputBase} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles( theme => ({
    textField: {
        border: '1px solid white',
        borderRadius:'2px',
        width:'50vw',
        color: 'white',
        fontFamily: 'Prompt',
        padding: '0.5vw',
        marginBottom: '0.5vh',
        fontSize: '1.7vh',
        [theme.breakpoints.up('sm')]: {
            width:'50vw',
            fontSize: '2.5vh',
        },
        [theme.breakpoints.up('md')]: {
            width:'30vw',
            fontSize: '2.5vh',
            marginBottom:'1vh'
        },
    },
    button: {
        border: '1px solid white',
        color: 'black',
        backgroundColor: 'white',
        height: '4vh',
        marginTop: '0.5vh',
        padding: '0px',
        [theme.breakpoints.up('sm')]: {  
            fontSize: '2.5vh',
            width: '15vw',
        },
        [theme.breakpoints.up('md')]: {  
            fontSize: '2.5vh',
            width: '10vw',
        },
    },
    disabledButton: {
        border: '1px solid white',
        height: '4vh',
        marginTop: '0.5vh',
        padding: '0px',
        '&:disabled': {
            color: 'white',
        } ,
        [theme.breakpoints.up('sm')]: {  
            fontSize: '2.5vh',
            width: '15vw',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2.5vh',
            width: '10vw',
        },
    }
}))     


function Footer() {
    const classes = useStyles()
    const [name, setName] = useState("")
    const [message, setMessage] = useState("")
    const isEnabled = name.length > 0 && message.length > 0;
    const [dialog, setDialog] = useState(false)
    const [sending, setSending] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault()
        setSending(true)
        emailjs.sendForm('service_6r4itir', 'template_65tojle', e.target, 'user_6B3zJ2pqXByk9urvYiiMK')
            .then((result) => {
                console.log(result.text);

                setDialog(true)
                setSending(false)
                setName("")
                setMessage("")
            }, (error) => {
                console.log(error.text);
            });
    }
    const handleNameChange = (e) => {
        setName(e.target.value)
    }
    const handleMessageChange = (e) => {
        setMessage(e.target.value)
    }
    useEffect(() => {
        setTimeout(() => {
            setDialog(false)
        },2000)
    },[dialog])
    return (
        <>
            <div className="footer-page">

                <hr style={{color:'grey'}}/>

                <div style={{
                    fontFamily: 'Prompt',
                    marginBottom:'2vh',
                    marginTop:'2vh',
                    marginLeft:'5vw',
                    marginRight:'5vw'
                }}>
                    <div className="quote">
                        " If you really look closely, most
                        overnight successes took a long time "
                        <br/>-- Steve Jobs
                    </div>
                </div>

                <div className="inner">
                <div className="form-container">
                    <div style={{
                        fontSize: '1.8vh',
                        fontWeight: 'bold',
                        color: 'grey'
                    }}>
                        LEAVE ME A COMMENT
                    </div>

                    <div>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <InputBase
                                    className={classes.textField}
                                    value={name}
                                    onChange={handleNameChange}
                                    name="from_name"
                                    placeholder="your name"
                                    variant="outlined"
                                    margin="dense"/>
                            </div>
                            <div>
                                <InputBase
                                    className={classes.textField}
                                    multiline
                                    rows={3}
                                    value={message}
                                    onChange={handleMessageChange}
                                    name="message"
                                    placeholder="your message"
                                    variant="outlined"
                                    margin="dense"/>
                            </div>
                            <div style={{
                                display:'flex',
                                alignItems:'center'
                            }}>
                                <Button
                                className={isEnabled ? classes.button : classes.disabledButton}
                                disabled={!isEnabled}
                                    type="submit"
                                    variant="contained"
                                    size="small">
                                        {
                                        sending ?
                                            <PulseLoader
                                                style={{
                                                    display: 'flex', 
                                                    justifyContent:'center', 
                                                    alignItems:'center'
                                                }}
                                                color="black"
                                                loading={sending}
                                                size={8} />
                                            :
                                            <div style={{
                                                fontFamily: 'Prompt',
                                                fontWeight: 'bold',
                                                textTransform:'lowercase'
                                            }}>
                                                send
                                            </div>
                                    }
                                </Button>                                
                                {
                                    dialog ?
                                
                                        <div className="sending-message">
                                            Thankyou for your message
                                            <img src={Smiley} alt="github"
                                                className="smiley" />
                                        </div>
                                        :
                                        <div></div>
                                }
                            </div>
                        </form>
                    </div>
                </div>

                {/* <div style={{
                    fontFamily: 'Prompt',
                    marginBottom:'2vh',
                    marginTop:'3vh',
                    textAlign: 'left',
                    marginLeft:'5vw'
                }}>
                    <div style={{
                        fontSize: '1.8vh',
                        fontWeight: 'bold',
                        color:'grey'
                    }}>MY RESUME</div>
                    <div style={{
                        fontSize: '1.7vh',
                        fontWeight: 'bold'
                    }}>
                        <a href="www.google.com" style={{
                            color:'white'
                        }}>
                            click here
                        </a>
                    </div>
                </div> */}
                
                <div className="contact-container">
                    <div style={{
                        fontSize: '1.8vh',
                        fontWeight: 'bold',
                        color:'grey'
                    }}>CONTACT ME AT</div>
                    <div className="mail">
                        priyanshubhardwaj19dec@gmail.com
                    </div>
                </div>

                <div className="find-container">
                    <div style={{
                        fontFamily: 'Prompt',
                        fontSize: '1.8vh',
                        fontWeight: 'bold',
                        color:'grey'
                    }}>
                        FIND ME ON 
                    </div>

                    <div style={{
                        display: 'flex'
                    }}>
                        <div>
                            <a href="https://github.com/priyanshu1912">
                                <img src={Github} alt="github"
                                    className="social-icons" />
                            </a>
                        </div>
                        
                        <div>
                            <a href="https://www.linkedin.com/in/priyanshu-bhardwaj-385896204/">
                            <img src={Linkedin} alt="linkedin"
                                className="social-icons" />
                            </a>
                        </div>

                        <div>
                            <a href="https://www.instagram.com/iam_priyanshu19/">
                            <img src={Instagram} alt="instagram"
                                className="social-icons" />
                            </a>
                        </div>

                        <div>
                            <a href="https://twitter.com/Priyanshuu19">
                                <img src={Twitter} alt="twitter"
                                    className="social-icons" />
                            </a>
                        </div>
                    </div>
                    </div>
                </div>
                <div style={{
                    fontFamily: 'Prompt',
                    fontSize: '1.7vh',
                    fontWeight: 'bold',
                    color: 'grey',
                    backgroundColor:'black',
                    padding:'2vh'
                }}>
                    Copyright | All Rights Reserved
                </div>

            </div>
            {/* <Dialog open={dialog} fullWidth maxWidth="xs">
                <DialogContent style={{
                        textAlign: 'center',
                        fontFamily: 'Montserrat',
                        fontSize: '2vh',
                        fontWeight:'bold'
                }}>
                    Thankyou for your message
                </DialogContent>
            </Dialog> */}
        </>
    )
}

export default Footer
